import { motion } from "framer-motion";
import { PROGRAMS } from "../data";

export const Programs = () => (
  <section id="programs" data-testid="programs-section" className="relative bg-forest py-28 md:py-40">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 md:mb-24"
      >
        <p className="text-xs tracking-[0.3em] uppercase text-amber mb-6" data-testid="programs-label">
          Signature Training Programmes
        </p>
        <h2 className="font-display text-4xl md:text-6xl tracking-tight text-cream leading-[1.05] max-w-3xl">
          Thematic missions, <span className="italic text-amber">engineered for leaders.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base md:text-lg text-cream/70 leading-relaxed">
          Designed with a blend of adventure, strategy and behavioural science — every programme is a
          narrative your team lives, not a slide deck they endure.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-cream/10 border border-cream/10">
        {PROGRAMS.map((p, i) => (
          <motion.div
            key={p.name}
            data-testid={`program-card-${p.name.toLowerCase().replace(/ /g, "-")}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group relative bg-forest p-10 md:p-14 hover:bg-moss transition-colors duration-500"
          >
            <div className="flex items-start justify-between mb-10">
              <span className="text-xs tracking-[0.25em] text-cream/50 uppercase">{p.code}</span>
              <span className="w-10 h-10 border border-amber/40 rotate-45 group-hover:rotate-[135deg] transition-transform duration-700" />
            </div>
            <h3 className="font-display text-4xl md:text-5xl tracking-tight text-cream group-hover:text-amber transition-colors duration-500 mb-5">
              {p.name}
            </h3>
            <p className="text-base leading-relaxed text-cream/70 mb-8 max-w-md">{p.description}</p>
            <div className="flex flex-wrap gap-3">
              {p.tags.map((t) => (
                <span key={t} className="text-[10px] tracking-[0.2em] uppercase text-amber border border-amber/30 px-3 py-1">
                  {t}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.3 }}
        className="mt-12 text-sm text-cream/50 tracking-wide"
        data-testid="programs-framework-note"
      >
        All programmes ride on the LEAP Leadership Competency Framework — Assess · Design · Experience · Debrief · Transform.
      </motion.p>
    </div>
  </section>
);
